import { jsPDF as JSPDF } from 'jspdf'
import { font, fontBold, headerImage } from './encodedAssets'
import { Text } from '../../../constants/TextConstants'

export const exportHTMLtoWord = (fileName, htmlContent) => {
  const source = 'data:application/msword;charset=utf-8,' + encodeURIComponent(htmlContent)
  const fileDownload = document.createElement('a')
  document.body.appendChild(fileDownload)
  fileDownload.href = source
  fileDownload.download = fileName
  fileDownload.click()
  document.body.removeChild(fileDownload)
}

export const exportHTMLtoPDF = (fileName, fullName, htmlContent, templateInfo) => {
  const isSummaryTemplate = templateInfo.value === 'EPAG_PAYMENTS' || templateInfo.value === 'EPAG_SUMMARY'
  const isGlobalTemplate = templateInfo.value === 'EPAG_GLOBAL'

  const landscapePDFConfig = {
    orientation: 'l',
    unit: 'pt',
    format: [1056, 612]
  }
  const portraitPDFConfig = {
    orientation: 'p',
    unit: 'pt',
    format: [792, 612]
  }

  const pdf = new JSPDF(isSummaryTemplate ? landscapePDFConfig : portraitPDFConfig)
  let margin = isSummaryTemplate ? 0 : [38, 38, 38, 38]

  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()

  if (isGlobalTemplate) {
    pdf.addFileToVFS('DavaSans-regular.ttf', font)
    pdf.addFont('DavaSans-regular.ttf', 'DavaSans', 'normal')
    pdf.addFileToVFS('DavaSans-bold.ttf', fontBold)
    pdf.addFont('DavaSans-bold.ttf', 'DavaSans', 'bold')

    pdf.addImage(
      'https://stepagdev.blob.core.windows.net/profileuserimagecontainer/EndavaFirstPage3.png',
      'JPEG',
      0,
      0,
      pageWidth,
      pageHeight
    )
    pdf.setFont('DavaSans', 'bold')
    pdf.setFontSize(40)
    pdf.setTextColor('#FFFFFF')
    const maxWidth = pageWidth - 140
    const splitFullName = (text, maxWidth) => {
      const lines = []
      let currentLine = ''
      const words = text.split(' ')

      words.forEach((word) => {
        const textLine = currentLine + (currentLine ? ' ' : '') + word
        const textWidth = pdf.getTextWidth(textLine)
        if (textWidth > maxWidth && currentLine) {
          lines.push(currentLine)
          currentLine = word
        } else {
          currentLine = textLine
        }
      })

      lines.push(currentLine)
      return lines
    }
    const fullNameLines = splitFullName(fullName, maxWidth)
    const lineHeight = 40

    if (fullNameLines.length === 1) {
      pdf.text(fullName, 75, 250, { baseline: 'middle' })
    } else {
      fullNameLines.forEach((line, index) => {
        pdf.text(line, 75, 250 + index * lineHeight, { baseline: 'middle' })
      })
    }
    margin = [75, 0, 80, 0]
    pdf.addPage()
  }

  pdf.html(htmlContent, {
    callback: function (pdf) {
      if (isGlobalTemplate) {
        const pageCount = pdf.internal.getNumberOfPages()
        for (let i = 2; i <= pageCount; i++) {
          pdf.setPage(i)

          // Header
          pdf.setFontSize(11)
          pdf.setTextColor('#babdbf')
          pdf.addImage(headerImage, 'JPEG', 55, 30, 90, 25, { baseline: 'top' })
          pdf.text(Text.Confidential, pageWidth - 62 - pdf.getTextWidth('Text.Confidential'), 35, { baseline: 'top' })

          // Footer
          const footerLeft = `${i}/${pageCount}`
          pdf.setFontSize(14)
          pdf.setFont('DavaSans', 'bold')
          pdf.setTextColor('#8e8e8e')
          pdf.text(footerLeft, 62, pageHeight - 30, { baseline: 'bottom' })
          pdf.setFontSize(12)
          pdf.text(fullName, pageWidth - 62 - pdf.getTextWidth(fullName), pageHeight - 45, { baseline: 'bottom' })
          pdf.setFont('DavaSans', 'normal')
          pdf.text(Text.Resume, pageWidth - 62 - pdf.getTextWidth(Text.Resume), pageHeight - 25, { baseline: 'bottom' })
        }
      }
      pdf.save(fileName)
    },
    autoPaging: 'text',
    margin
  })
}
